import { getSubscriptionCancellationRequestsDt } from "~/helpers/backendHelper";
import { getSubscriptionCancellationRequestsDtOk, getSubscriptionCancellationRequestsDtErr } from "./actions";
import { GET_SUBSCRIPTION_CANCELLATION_REQUESTS_DT } from "./actionTypes";
import { takeEvery, put, call } from "redux-saga/effects";

/********** DATATABLE **********/

function* onGetSubscriptionCancellationRequestsDt({ payload: { params } }) {
  try {
    const response = yield call(getSubscriptionCancellationRequestsDt, params);
    yield put(getSubscriptionCancellationRequestsDtOk(response));
  } catch (error) {
    yield put(getSubscriptionCancellationRequestsDtErr(error));
  }
}

function* cancellationRequestsSaga() {
  yield takeEvery(GET_SUBSCRIPTION_CANCELLATION_REQUESTS_DT, onGetSubscriptionCancellationRequestsDt);
}

export default cancellationRequestsSaga;